@if (totalPage>1) {
  <div class="{{pageClass}}">
    <div class=" row mt-5">
      <div class="col-sm-12 no-padding ">
        <div class="btn-toolbar float-right " role="toolbar ">
          <div class="pagination-action">
            <button id="firstBtn " title="First" class="btn btn-xs fn-pagging-btn " (click)="firstPage() " [disabled]="currentPage==1 ">
              <i class="fn-global-double-angle rotate-180"></i>
            </button>
            <button id="prevBtn " title="Prev" class="btn btn-xs fn-pagging-btn " [disabled]="currentPage==1" (click)="prevPage() ">
              <i class="fn-global-angle rotate-180"></i>
            </button>
            <button id="labelBtn " class="btn btn-xs fn-pagging-btn pagination-count " disabled="disabled ">
            {{currentPage}}/{{totalPage}}</button>
            <button id="nextBtn " class="btn btn-xs fn-pagging-btn " title="Next" [disabled]="currentPage == totalPage "
              (click)="nextPage() ">
              <i class="fn-global-angle"></i>
            </button>
            <button id="lastBtn " class="btn btn-xs fn-pagging-btn "  title="Last" [disabled]="currentPage==totalPage "
              (click)="lastPage() ">
              <i class="fn-global-double-angle"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
